import CityPageTemplate from "../city-template/CityPageTemplate";
import { hollandConfig } from "./data";

export default function HollandPage() {
  return <CityPageTemplate config={hollandConfig} />;
}